import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Landing from "@/pages/Landing";
import Links from "@/pages/Links";
import Grazie from "@/pages/Grazie";
import Prenota from "@/pages/Prenota";
import Admin from "@/pages/Admin";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/links" element={<Links />} />
          <Route path="/grazie" element={<Grazie />} />
          <Route path="/prenota" element={<Prenota />} />
          <Route
            path="/*"
            element={
              <ClerkAuthProvider>
                <Routes>
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/sign-in/*" element={<SignInPage />} />
                  <Route path="/sign-up/*" element={<SignUpPage />} />
                  <Route path="*" element={<Landing />} />
                </Routes>
              </ClerkAuthProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
